import axios from "axios";
import React, { useState, useEffect } from "react";
import { Map, MapStyle, Marker, Popup } from "@maptiler/sdk";
import "@maptiler/sdk/dist/maptiler-sdk.css";

// Define types for the data structure
interface Atase {
  atpolstp_id: string;
  atpolstp_title: string;
  atpolstp_nama: string;
  atpolstp_foto: string;
  atpolstp_konten: string;
  longitude: number; // Assuming you have longitude in your data
  latitude: number; // Assuming you have latitude in your data
}

interface Staftek {
  atpolstp_id: string;
  atpolstp_title: string;
  atpolstp_nama: string;
  atpolstp_foto: string;
  atpolstp_konten: string;
  longitude: number; // Assuming you have longitude in your data
  latitude: number; // Assuming you have latitude in your data
}

const LOAsing: React.FC = () => {
  const [atase, setAtase] = useState<Atase[]>([]);
  const [staftek, setStaftek] = useState<Staftek[]>([]); // Adjust type as needed

  useEffect(() => {
    const getAtase = async () => {
      const response = await axios.get(
        "https://divhubinter.polri.go.id/api/view_atase",
      );
      setAtase(response.data.atase.data);
    };

    getAtase();
  }, []);

  useEffect(() => {
    const getStaftek = async () => {
      const response = await axios.get(
        "https://divhubinter.polri.go.id/api/view_staftek",
      );
      setStaftek(response.data.staf_teknis.data);
    };

    getStaftek();
  }, []);

  useEffect(() => {
    const map = new Map({
      container: "map", // ID of the container element
      style: MapStyle.STREETS,
      center: [0, 0], // Initial map center [longitude, latitude]
      zoom: 1.2, // Initial zoom level
      apiKey: "5dcB35LlYp3fBehT0ma2",
    });

    // Add markers for each atase
    atase.forEach((item) => {
      new Marker({
        draggable: false,
      })
        .setLngLat([item.longitude, item.latitude])
        .setPopup(
          new Popup({ closeButton: false }).setHTML(
            `
            <p class="text-md font-bold text-gray-900">${item.atpolstp_nama || "No Name"}</p>
            <p class="text-md text-gray-600">ATASE POLRI KBRI ${item.atpolstp_title || "No Title"}</p>
            <a target="_blank" rel="noopener noreferrer" href=http://maps.google.com/maps?z=12&t=m&q=${item.latitude},${item.longitude} >
              <p class="text-md text-blue-600">Google Maps</p>
            </a>

            `,
          ),
        ) // Popup content
        .addTo(map); // Add marker to the map
    });

    staftek.forEach((staf) => {
      new Marker({
        draggable: false,
        color: "#FF2D00",
      })
        .setLngLat([staf.longitude, staf.latitude])
        .setPopup(
          new Popup({ closeButton: false }).setHTML(
            `
            <p class="text-md font-bold text-gray-900">${staf.atpolstp_nama || "No Name"}</p>
            <p class="text-md text-gray-600">STAF TEKNIS POLRI KJRI ${staf.atpolstp_title || "No Title"}</p>
            <a target="_blank" rel="noopener noreferrer" href=http://maps.google.com/maps?z=12&t=m&q=${staf.latitude},${staf.longitude} >
              <p class="text-md text-blue-600">Google Maps</p>
            </a>

            `,
          ),
        ) // Popup content
        .addTo(map); // Add marker to the map
    });

    return () => {
      map.remove(); // Cleanup on component unmount
    };
  }, [atase, staftek]);

  return (
    <div>
      <div className="container mx-auto px-12 py-8">
        <h2 className="text-4xl font-bold pb-4">ATPOL & STP</h2>

        {/* Global Map Container */}
        <div
          id="map"
          style={{ height: "768px", width: "100%" }}
          className="bg-neutral"
        ></div>

        {/* ATPOL */}
        <div className="flex flex-col mt-8 px-6 gap-6">
          <div className="flex flex-col gap-4">
            <div className="text-3xl font-bold">ATASE POLRI</div>
            <div className="laptop:grid laptop:grid-cols-2 gap-6 laptop:px-4">
              {atase.map((item) => (
                <div key={item.atpolstp_id}>
                  <div className="flex flex-flex-row gap-6">
                    <div className="relative overflow-hidden w-1/2 rounded-lg">
                      <div className="mx-auto max-w-screen">
                        <img
                          src={`https://divhubinter.polri.go.id${item.atpolstp_foto}`}
                          alt=""
                          width={0}
                          height={0}
                          sizes="100vw"
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-4 w-3/4">
                      <div className="">
                        <p className="text-2xl font-bold">
                          ATASE POLRI KBRI {item.atpolstp_title}
                        </p>
                        <p className="text-xl">{item.atpolstp_nama}</p>
                      </div>
                      <div className="flex flex-col gap-3">
                        <div className="text-lg">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.atpolstp_konten,
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4 mt-6">
            <div className="text-3xl font-bold">STAF TEKNIS POLRI</div>
            <div className="laptop:grid laptop:grid-cols-2 gap-6 laptop:px-4">
              {staftek.map((staf) => (
                <div key={staf.atpolstp_id}>
                  <div className="flex flex-flex-row gap-6">
                    <div className="relative overflow-hidden w-1/2 rounded-lg">
                      <div className="mx-auto max-w-screen">
                        <img
                          src={
                            `https://divhubinter.polri.go.id` +
                            staf.atpolstp_foto
                          }
                          alt=""
                          width={0}
                          height={0}
                          sizes="100vw"
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-4 w-3/4">
                      <div className="">
                        <p className="text-2xl font-bold">
                          STAF TEKNIS POLRI KJRI {staf.atpolstp_title}
                        </p>
                        <p className="text-xl">{staf.atpolstp_nama}</p>
                      </div>
                      <div className="flex flex-col gap-3">
                        <div className="text-lg">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: staf.atpolstp_konten,
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LOAsing;
